var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    fillRule: "evenodd",
    d: "M20.625 10.875c.094 0 .18.04.258.117.078.078.117.164.117.258v1.5c0 .094-.04.18-.117.258-.078.078-.164.117-.258.117h-7.5v7.5c0 .094-.04.18-.117.258-.078.078-.164.117-.258.117h-1.5c-.094 0-.18-.04-.258-.117-.078-.078-.117-.164-.117-.258v-7.5h-7.5c-.094 0-.18-.039-.258-.117C3.04 12.93 3 12.844 3 12.75v-1.5c0-.094.04-.18.117-.258.078-.078.164-.117.258-.117h7.5v-7.5c0-.094.039-.18.117-.258.078-.078.164-.117.258-.117h1.5c.094 0 .18.04.258.117.078.078.117.164.117.258v7.5h7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ddd3f5b59fbdb729bdcbfb6c8ccda3ed.svg";
export { ForwardRef as ReactComponent };